import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListItems, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { doGetMonthlySalaryApply, doRecalculation, doDeleteMonthlySalaryApply, doExportSalary } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import SelectExportDiv from './SelectExportDiv'
class MonthlySalaryApplyDetail extends React.Component {
    state = {
        changedValues基本信息: {},
        bSave: false
    }

    componentDidMount = () => {
        this.doGetMonthlySalaryApply(this.props.id)
    }

    doGetMonthlySalaryApply = (id) => {
        const { dispatch } = this.props
        dispatch(doGetMonthlySalaryApply({
            id: id || 0,
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ bSave: false })
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        }))
    }

    handlerRecalculation = () => {
        const { dispatch, id } = this.props
        const { bSave } = this.state
        if (!bSave) {
            this.setState({ bSave: true })
            dispatch(doRecalculation({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        this.setState({ bSave: false })
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        Ext.toast('重新计算成功')
                        this.doGetMonthlySalaryApply(id)
                    }
                }
            }))
        }
    }

    handlerDelete = () => {
        const { dispatch, onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteMonthlySalaryApply',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息, optionsParas } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0
    }

    handelExportBonus = () => {
        const { id } = this.props
        // Tyan.pubForm.showExport({ event: 'ExportSalary', eventData: { id }, title: '导出月薪明细' })
        Tyan.pubForm.showDialog('导出', props => <SelectExportDiv {...props} id={id} />)
    }

    handleExportTaxData = () => {
        const { id } = this.props
        Tyan.pubForm.showExport({ event: 'ExportTaxData', eventData: { id }, title: '导出税务系统数据' })
    }
    fieldset基本信息 = () => {
        return [
            {
                _group: '', minWidth: '95%', flex: 0, items: [
                    { _text: '发放月份', name: '薪资期号', minWidth: '250', disabled: true },
                    { _date: '薪资给付日', minWidth: '300', disabled: true, align: 'left' },
                    { _int: '总人数', minWidth: '200', disabled: true },
                    { _label: '', flex: 60 }
                ]
            },
            {
                _group: '', minWidth: '95%', flex: 0, items: [
                    { _text: '创建人', minWidth: '10%', disabled: true },
                    { _date: '创建时间', minWidth: '10%', disabled: true },
                    { _text: '修改人', minWidth: '10%', disabled: true },
                    { _date: '修改时间', minWidth: '10%', disabled: true },
                ]
            },]
    }

    fieldset月薪记录 = () => {
        const { optionsParas } = this.state
        const 显示列 = optionsParas['显示列']
        return [
            {
                _grid: '', name: '薪资明细', minWidth: '95%', lockable: true, height: '100%', columns: [
                    { _text: '员工编号', minWidth: 100, locked: 'left' },
                    { _text: '员工姓名', minWidth: 100, locked: 'left' }
                ].concat(显示列.map(o => {
                    return { _float: o.showName, name: o.name, minWidth: o.showName.length * 17, zeroValue: null,
                        tooltip: data => {
                        const remark = data['remark_' + o.name]
                        return remark
                    }, }
                }))
            },
        ]
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    fieldset签核流程 = () => {
        return [
            { _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 状态名称, 提交时间 } = initValues基本信息
        return <Body data={this} fullForm={true}
            controls={
                readOnly ? [
                    { _button: '导出', icon: 'save', handler: () => this.handelExportBonus(),/*  cdt: () => 状态 == 3, */ },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    { _button: '导出税务系统数据', icon: 'save', handler: () => this.handleExportTaxData(), },
                ] : [
                    { _button: '导出', icon: 'save', handler: () => this.handelExportBonus()/* , cdt: () => 状态 == 3 */, },
                    { _button: '导出税务系统数据', icon: 'search', handler: () => this.handleExportTaxData(), },
                    { _flow: 'SalaryApplyFlow', disabled: this.bSave(), cdt: () => id > 0, id: getFormValue(this, '基本信息', 'ArchivesID') },
                    { _button: '重新计算', icon: 'save', handler: () => this.handlerRecalculation(), disabled: this.bSave(), cdt: () => 状态名称 == '月薪制作' },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => 状态名称 == '月薪制作' && 提交时间 == nullDate, disabled: this.bSave(), },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '基本信息', name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'top', },
                    {
                        _fieldsets: [
                            { title: '月薪记录', name: '基本信息', _fieldset: this.fieldset月薪记录(), disabled: true, fullblock: true },
                            { title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
                            { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                        ]
                    }
                ]
            }
        />
    }
}

export default connect()(MonthlySalaryApplyDetail)